import React from "react";
import { Row, Col, Card, Button } from "antd";
import "./index.css";
const AccountInfo = ({ companyDetails, isOpenSubcriptionModal }) => {
  return (
    <Row justify="center">
      <Col xs={24} sm={24} md={24} lg={24} xl={24}>
        <Row justify="start">
          <Col
            xs={24}
            sm={24}
            md={22}
            lg={24}
            xl={24}
            style={{ border: "0.5px solid #eaefef" }}
          >
            <Card>
              <Row justify="start" align="top">
                <Col span={24}>
                  <p className="text-left st-cardheadingtext" >Account Information</p>
                </Col>
                <Col xs={10} sm={10} md={10} lg={8} xl={6} className="text-left" style={{ marginTop: '2rem' }}>
                  <button className="active-btn-flat text-left">Active</button>
                  {/* <Button className="account-btn">Active</Button> */}
                </Col>
                <Col xs={17} sm={17} md={14} lg={16} xl={18} style={{ marginTop: '2rem' }} >
                  <p className="account-description text-left">
                    {companyDetails?.subscription_status === "cancel_at_period_end" &&
                      `This subscription will permanently expire after ${companyDetails.subscription_period_end}.`
                    }
                    {companyDetails?.subscription_status === "ok" &&
                      ` You have subscribed for this service until ${companyDetails.subscription_period_end}. Card Used **** **** **** 4242`
                    }
                  </p>
                  <p
                    className="account-subscription pointer-cursor"
                    onClick={isOpenSubcriptionModal}
                  >
                    Manage subscription
                  </p>
                </Col>
              </Row>
            </Card>
          </Col>
        </Row>
      </Col >
    </Row >
  );
};

export default AccountInfo;
